import type { Lang, Dictionary } from "./types";
import { it } from "./it";
import { en } from "./en";

export type { Lang, Dictionary, ServiceItem, MethodStep } from "./types";

export const dictionaries: Record<Lang, Dictionary> = { it, en };

export function getDictionary(lang: Lang): Dictionary {
  return dictionaries[lang];
}

export function resolveInitialLang(stored: string | null, navLang: string | undefined): Lang {
  if (stored === "it" || stored === "en") return stored;
  if (navLang && navLang.toLowerCase().startsWith("en")) return "en";
  return "it";
}
